var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-builder-video-preview embed-responsive",class:("embed-responsive-" + _vm.ratio)},[_vm._v(" "+_vm._s(_vm.videoSrc)+" "),_c('iframe',{staticClass:"embed-responsive-item",attrs:{"src":_vm.videoSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }